import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export function useFundingFunnel(client, observation, t0) {
  const $ = _c(9);
  const enabled = t0 === undefined ? true : t0;
  const {
    stage,
    outcome,
    method,
    operationId,
    errorCode
  } = observation;
  let t1;
  let t2;
  if ($[0] !== client || $[1] !== enabled || $[2] !== errorCode || $[3] !== method || $[4] !== operationId || $[5] !== outcome || $[6] !== stage) {
    t1 = () => {
      if (!enabled) {
        return;
      }
      client.observeFunnel?.({
        stage,
        outcome,
        method: method ?? null,
        operationId: operationId ?? null,
        errorCode: errorCode ?? null
      });
    };
    t2 = [client, stage, outcome, method, operationId, errorCode, enabled];
    $[0] = client;
    $[1] = enabled;
    $[2] = errorCode;
    $[3] = method;
    $[4] = operationId;
    $[5] = outcome;
    $[6] = stage;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
}